import { useState } from 'react';
import { AssignYardsAndClientsModal } from '../../../design-system';
import { ClientsPage, ClientsHeader, ClientsBody } from './ClientsComponents';
import { RoleGuard } from '../../../routes';

export const Clients = () => {
  const [totalCount, setTotalCount] = useState(0);

  return (
    <RoleGuard roles={'adminRead'}>
      <ClientsPage innerScroll>
        <ClientsHeader totalCount={totalCount} />
        <ClientsBody setTotalCount={setTotalCount} />
      </ClientsPage>
      <AssignYardsAndClientsModal />
    </RoleGuard>
  );
};
